import Vue from 'vue';
import state from '../state';

const getMultiplier = exp => Math.pow(10, exp);

let currenciesPromise = null;

export default {
  ensure() {
    if (!currenciesPromise) {
      currenciesPromise = Vue.http.get('/api/currencies');
      currenciesPromise.then(response => {
        state.currencies.set(response.data);
      });
    }
    return currenciesPromise;
  },
  async reloadAll() {
    const currencies = (await Vue.http.get('/api/currencies')).data;
    state.currencies.set(currencies);
  },
  unset() {
    state.currencies.set([]);
    currenciesPromise = null;
  },
  format(sourceAmount, currencyId) {
    const currency = state.currencies.getCurrency(currencyId);
    if (!currency) return sourceAmount;
    const locale = navigator.language || navigator.userLanguage;
    const amount = sourceAmount / getMultiplier(currency.decimals);
    const amountStr = amount.toLocaleString(locale, { minimumFractionDigits: currency.decimals });
    return currency.symbol.length === 1 ? `${currency.symbol}${amountStr}` : `${amountStr} ${currency.symbol}`;
  },
  fromSource(amount, currencyId) {
    const currency = state.currencies.getCurrency(currencyId);
    const decimals = ((currency && currency.decimals) || 0);
    return amount / getMultiplier(decimals);
  },
  toSource(amount, currencyId) {
    const currency = state.currencies.getCurrency(currencyId);
    const decimals = ((currency && currency.decimals) || 0);
    return parseInt(amount * getMultiplier(decimals));
  },
  formatInvariant(sourceAmount, currencyId) {
    const currency = state.currencies.getCurrency(currencyId);
    const decimals = ((currency && currency.decimals) || 0);
    const amount = sourceAmount / getMultiplier(decimals);
    return amount.toFixed(decimals);
  },
  getMinimal(currencyId) {
    const currency = state.currencies.getCurrency(currencyId);
    const decimals = ((currency && currency.decimals) || 0);
    const amount = 1 / getMultiplier(decimals);
    return amount.toFixed(decimals);
  },
  async create(currency) {
    return (await Vue.http.post('/api/currencies', currency)).data;
  }
}



// WEBPACK FOOTER //
// ./src/services/currency.service.js